/*
 * Клиент бэкенд-плагина defectdojo (packages/backend/src/modules/defectdojo.ts): находки
 * безопасности продукта DefectDojo кластера. Продукт = путь проекта GitLab (аннотация
 * gitlab.com/project-slug — под этим именем джоба app:defectdojo импортирует отчёты), кластер —
 * аннотация viva.company.com/cluster; адрес DefectDojo бэкенд находит по каталогу сам.
 */
import { createApiRef, DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';

export type Finding = {
  id: number;
  title: string;
  severity: string;
  active: boolean;
  verified: boolean;
  mitigated: boolean;
  duplicate: boolean;
  cwe?: number;
  cve?: string;
  vulnIds: string[];
  filePath?: string;
  line?: number;
  component?: string;
  componentVersion?: string;
  test: string;
  found: string;
  url: string;
};

export type ProductFindings = {
  cluster: string;
  dojoUrl: string;
  product?: { id: number; name: string; url: string };
  summary: Record<string, number>;
  tests: { id: number; title: string; scanType: string; updated: string; findings: number; url: string }[];
  findings: Finding[];
};

export interface DefectDojoApi {
  getFindings(cluster: string, product: string): Promise<ProductFindings>;
}

export const defectdojoApiRef = createApiRef<DefectDojoApi>({ id: 'plugin.viva.defectdojo' });

export class DefectDojoApiClient implements DefectDojoApi {
  constructor(private readonly options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {}

  async getFindings(cluster: string, product: string): Promise<ProductFindings> {
    const baseUrl = await this.options.discoveryApi.getBaseUrl('defectdojo');
    const response = await this.options.fetchApi.fetch(
      `${baseUrl}/clusters/${encodeURIComponent(cluster)}/products/${encodeURIComponent(product)}/findings`,
    );
    if (!response.ok) {
      const payload = await response.json().catch(() => ({}));
      throw new Error(payload?.error?.message ?? `DefectDojo request failed with status ${response.status}`);
    }
    return (await response.json()) as ProductFindings;
  }
}
